import { ref, computed } from 'vue';
import { AliOssUpload } from '@/utils/ali-oss';
import { Message } from 'irm-ui';
import i18n from '@/locales';

export const useFileUpload = (options = {}) => {
	const { limit = 10, accept = ['pdf', 'doc', 'docx', 'xlsx'], onUpload, onStart, onFinish } = options;

	const uploadExt = ref(accept);
	const formatUploadExt = computed(() => uploadExt.value.map(type => `.${type}`).toString());

	const beforeFileUpload = file => {
		const isFile = uploadExt.value.includes(file.name.split('.').at(-1));
		const isLt10M = file.size / 1024 / 1024 < limit;

		if (!isFile) {
			Message.error(i18n.t('enterprise.field.upload-file-format-error'));
		}
		if (!isLt10M) {
			Message.error(i18n.t('enterprise.field.upload-file-size-limit', { limit }));
		}
		return isFile && isLt10M;
	};
	const uploadFile = async ({ file }) => {
		const ext = file.name.split('.').at(-1);
		if (!uploadExt.value.includes(ext)) {
			Message.warning(i18n.t('enterprise.field.upload-file-format-unsupported'));
			return false;
		}

		startUpload();
		const extension = file.name.split('.').pop();
		const res = await AliOssUpload({
			file: file,
			originName: new Date().getTime() + '.' + extension
		});
		const data = {
			...res,
			name: file.name
		};
		onUpload && onUpload(data);
		finishUpload();
	};

	const uploading = ref(false);
	const setUploading = value => {
		uploading.value = value;
	};

	const startUpload = () => {
		onStart && onStart();
		setUploading(true);
	};
	const finishUpload = () => {
		onFinish && onFinish();
		setUploading(false);
	};

	return {
		beforeFileUpload,
		uploadFile,
		formatUploadExt,
		uploading
	};
};
